export const CRM = { // Layout page
  path: '/crm',
  component: () => import('@/View/CRM/layout/layout.vue'),
  hidden: true,
  redirect: '/crm/dashboard',
  name: 'CRM',
  meta: {
    title: 'CRM',
    selected: false,
    permissionList: ['abc', 'def']
  },
  children: [
    { // CRM dashboard start
      path: '/crm/dashboard',
      component: () => import('@/View/CRM/dashboard/dashboard.vue'),
      hidden: false,
      icon: 'dashboard',
      name: 'CRMDashboard',
      meta: {
        breadCrumb: 'CRM',
        title: 'Dashboard',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // CRM dashboard start
      path: '/crm/activityLog',
      component: () => import('@/View/CRM/ActivityLog/main.vue'),
      hidden: false,
      icon: 'fas fa-clock',
      name: 'ActivityLog',
      meta: {
        breadCrumb: 'ActivityLog',
        title: 'Activity Log',
        selected: true,
        permissionList: ['abc', 'def']
      },
      children: []
    },
    {
      path: '/crm/Customers',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      icon: 'fas fa-users',
      name: 'Customers',
      redirect: '/crm/customers/customerList',
      meta: {
        breadCrumb: 'Customers',
        title: 'Customers',
        selected: true,
        permissionSlug: 'customer',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [
        // CRM Customer List
        {
          path: '/crm/customers/customerList',
          component: () => import('@/View/CRM/Cutomers/customerList.vue'),
          hidden: false,
          name: 'CustomerList',
          meta: {
            breadCrumb: 'CustomerList',
            title: 'List',
            selected: true
          }
        },
        // Add Customer/Vendor/Lead Common Page
        {
          path: '/crm/customers/addCustomer',
          component: () => import('@/View/CRM/CommonAdd/commonAdd.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'AddCustomer',
          meta: {
            breadCrumb: 'Customer',
            title: 'Add',
            selected: true,
            permissionSlug: 'customer',
            routeTo: 'Customers'
          }
        },
        {
          path: '/crm/customers/customerDetails/:customerId',
          component: () => import('@/View/CRM/Details/main.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'CustomerDetails',
          meta: {
            breadCrumb: 'Customer',
            title: 'Details',
            selected: true,
            permissionSlug: 'customer'
          }
        }
      ]
    },
    // VENDOR
    {
      path: '/crm/vendors',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      icon: 'fas fa-hand-holding-usd',
      name: 'Vendors',
      redirect: '/crm/vendors/vendorList',
      meta: {
        breadCrumb: 'Vendors',
        title: 'Vendors',
        selected: true,
        permissionSlug: 'vendor',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [
        {
          path: '/crm/vendors/vendorList',
          component: () => import('@/View/CRM/Vendor/vendor.vue'),
          name: 'VendorList',
          meta: {
            breadCrumb: 'VendorList',
            title: 'List',
            selected: true
          }
        },
        {
          path: '/crm/vendors/addVendor',
          component: () => import('@/View/CRM/CommonAdd/commonAdd.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'AddVendor',
          meta: {
            breadCrumb: 'Vendor',
            title: 'Add',
            selected: true,
            routeTo: 'Vendors',
            permissionSlug: 'vendor'
          }
        },
        {
          path: '/crm/vendors/vendorDetails/:customerId',
          component: () => import('@/View/CRM/Details/main.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'VendorDetails',
          meta: {
            breadCrumb: 'Vendor',
            title: 'Details',
            selected: true,
            permissionSlug: 'vendor'
          }
        }
      ]
    },
    // LEADS
    {
      path: '/crm/leads',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      icon: 'mdi mdi-account-clock',
      name: 'Leads',
      redirect: '/crm/leads/leadList',
      meta: {
        breadCrumb: 'Leads',
        title: 'Leads',
        selected: true,
        permissionSlug: 'lead',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [
        // Lead
        {
          path: '/crm/leads/leadList',
          component: () => import('@/View/CRM/Leads/leads.vue'),
          name: 'LeadList',
          meta: {
            breadCrumb: 'LeadList',
            title: 'List',
            selected: true
          }
        },
        {
          path: '/crm/leads/addLead',
          component: () => import('@/View/CRM/CommonAdd/commonAdd.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'AddLead',
          meta: {
            breadCrumb: 'Lead',
            title: 'Add',
            selected: true,
            routeTo: 'Leads',
            permissionSlug: 'lead'
          }
        },
        {
          path: '/crm/leads/leadDetails/:customerId',
          component: () => import('@/View/CRM/Details/main.vue'),
          hidden: true,
          icon: 'fas fa-users',
          name: 'LeadDetails',
          meta: {
            breadCrumb: 'Lead',
            title: 'Details',
            selected: true,
            permissionSlug: 'lead'
          }
        }
      ]
    },
    { // Order object start
      path: '/crm/order',
      component: () => import('@/View/Manufacture/main/index.vue'),
      hidden: false,
      redirect: {name: 'OrderList'},
      name: 'Order',
      icon: 'fa fa-shopping-basket',
      meta: {
        breadCrumb: 'Order',
        title: 'Order',
        icon: 'fa fa-shopping-basket',
        selected: false,
        permissionSlug: 'order',
        permissionList: ['isViewAll', 'isViewRelated']
      },
      children: [{
        path: '/crm/order/orderList',
        component: () => import('@/View/CRM/Orders/OrderList.vue'),
        name: 'OrderList',
        meta: {
          breadCrumb: 'OrderList',
          icon: 'fa fa-shopping-basket',
          title: 'List',
          permissionSlug: 'order',
          permissionList: ['isViewAll', 'isViewRelated']
        }
      },
      {
        path: '/crm/order/newOrder/:orderId',
        component: () => import('@/View/CRM/Orders/NewOrder.vue'),
        name: 'NewOrder',
        meta: {
          breadCrumb: 'Order',
          icon: 'fa fa-shopping-basket',
          title: 'Add',
          permissionList: ['isViewAll', 'isViewRelated']
        }
      },
      {
        path: '/crm/order/orderDetails/:orderId',
        component: () => import('@/View/CRM/Orders/OrderDetails.vue'),
        name: 'OrderDetails',
        meta: {
          breadCrumb: 'Order',
          icon: 'fa fa-shopping-basket',
          title: 'Details',
          permissionList: ['isViewAll', 'isViewRelated']
        }
      }]
    },
    { // CRM dashboard start
      path: '/crm/settings',
      component: () => import('@/View/CRM/settings/main.vue'),
      hidden: false,
      icon: 'fas fa-cogs',
      name: 'Settings',
      redirect: '/crm/settings/dashboard',
      meta: {
        breadCrumb: 'Settings',
        title: 'Settings',
        selected: true,
        permissionSlug: 'crm_settings',
        permissionList: ['']
      },
      children: [
        { // CRM dashboard start
          path: '/crm/settings/dashboard',
          component: () => import('@/View/CRM/settings/dashboard.vue'),
          hidden: true,
          icon: 'dashboard',
          name: 'CRMSettingDashboard',
          meta: {
            color: '#26c6da',
            breadCrumb: 'Settings',
            title: 'Dashboard',
            selected: false,
            permissionList: []
          }
        },
        { // CRM dashboard start
          path: '/crm/settings/contact/designation',
          component: () => import('@/View/CRM/settings/ContactDesignation/designationList.vue'),
          hidden: false,
          icon: 'fas fa-user-tie',
          name: 'ContactDesignation',
          meta: {
            color: '#07575B',
            breadCrumb: 'ContactDesignation',
            title: 'Contact Designation',
            permissionSlug: 'contact_designation',
            selected: true,
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/crm/settings/lead/source',
          component: () => import('@/View/CRM/settings/LeadSource/sourceList.vue'),
          hidden: false,
          icon: 'fas fa-info',
          name: 'LeadSource',
          meta: {
            color: '#f52549',
            breadCrumb: 'Lead',
            title: 'Lead Source',
            permissionSlug: 'lead_source',
            selected: true,
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/crm/settings/lead/status',
          component: () => import('@/View/CRM/settings/LeadStatus/statusList.vue'),
          hidden: false,
          icon: 'fas fa-question',
          name: 'LeadStatus',
          meta: {
            color: 'purple',
            breadCrumb: 'Lead',
            title: 'Lead Status',
            permissionSlug: 'lead_status',
            selected: true,
            permissionList: ['isViewAll']
          }
        },
        // {
        //   path: '/crm/settings/opportunityStatus',
        //   component: () => import('@/View/CRM/settings/OpportunityStatus/statusList.vue'),
        //   hidden: false,
        //   icon: 'fas fa-comment-dollar',
        //   name: 'OpportunityStatus',
        //   meta: {
        //     color: '#1e88e5',
        //     breadCrumb: 'Opportunity',
        //     title: 'Opportunity Status',
        //     selected: true,
        //     permissionList: ['abc', 'def']
        //   }
        // },
        // {
        //   path: '/crm/settings/opportunitySource',
        //   component: () => import('@/View/CRM/settings/OpportunitySource/sourceList.vue'),
        //   hidden: false,
        //   icon: 'fas fa-search-dollar',
        //   name: 'OpportunitySource',
        //   meta: {
        //     color: '#F78B2D',
        //     breadCrumb: 'Opportunity',
        //     title: 'Opportunity Source',
        //     selected: true,
        //     permissionList: ['abc', 'def']
        //   }
        // },
        {
          path: '/crm/settings/contact/role',
          component: () => import('@/View/CRM/settings/ContactRole/roleList.vue'),
          hidden: true,
          icon: 'fas fa-user-tag',
          name: 'ContactRole',
          meta: {
            color: 'teal',
            breadCrumb: 'Contact',
            title: 'Contact Role',
            permissionSlug: 'contact_role',
            selected: true,
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/crm/settings/contact/type',
          component: () => import('@/View/CRM/settings/ContactType/typeList.vue'),
          hidden: false,
          icon: 'fas fa-user',
          name: 'ContactType',
          meta: {
            color: 'cyan',
            breadCrumb: 'Contact',
            title: 'Contact Type',
            selected: true,
            permissionSlug: 'contact_type',
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/crm/settings/order/status',
          component: () => import('@/View/CRM/settings/OrderStatus/statusList.vue'),
          hidden: false,
          icon: 'fa fa-shopping-basket',
          name: 'OrderStatus',
          meta: {
            color: '#8c9eff',
            breadCrumb: 'OrderStatus',
            title: 'Order Status',
            permissionSlug: 'order_status',
            selected: true,
            permissionList: ['isViewAll']
          }
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/View/CRM/router/index.js